import React from 'react';
import {
    Grid,
    Row,
    Checkbox,
    DropdownMenu
} from 'cdk-radial';
import { AiFillBank,AiFillCreditCard } from 'react-icons/ai';
const LOCATION_LABEL_STYLE = {
    color: '#151B25',
    fontFamily: 'Roboto',
    fontSize: '15px',
    letterSpacing: 0,
    lineHeight: '20px',
    paddingTop: '10px'
};

const SavedPaymentMethod =({data,
  checkBoxHandler,
  dropdownSelectionHandler,
  isCheckBoxChecked,
  last4,
  formError})=>{
    const CURSOR_POINTER = 'pointer';
    const CURSOR_NODROP = 'no-drop'; 
    const creditCardScreenMessage='Use Saved Credit Card Information?';
    const achScreenMessage='Use Saved Bank Account?'
    const STRIPECARD='stripe_card';
    const STRIPEBANK='stripe_bank'
    return (
      <div className="payment_checkout_tab">
                <form> 
                       <Grid className="checkout-existing-payment-form"> 
                        <Row>
                        <Checkbox
                          dataTestId="checkbox"
                          hideLabel={false}
                          indeterminate={false}
                          isDisabled={false}
                          id="chkExistingPaymentMethod"
                          label={
                            <span style={LOCATION_LABEL_STYLE}>{data.length>0 && data[0].payment_type===STRIPECARD?creditCardScreenMessage:achScreenMessage}</span>
                          }
                          name="chkExistingPaymentMethod"
                          onChange={checkBoxHandler}
                          checked={isCheckBoxChecked}
                          style={{ cursor: false ? CURSOR_NODROP : CURSOR_POINTER }}
                        />
                      </Row> 
                      <Row>
                           <DropdownMenu
                                required
                                enableCustomValidation
                                hasError={formError.existingPayment}
                                isDisabled={!isCheckBoxChecked}
                                label="Select Saved Last4 Digit"
                                fullWidth
                                value={{ value: `XXXX-XXXX-XXXX-${last4}`, 
                                  label: `XXXX-XXXX-XXXX-${last4}`,
                                   icon:<AiFillBank/>
                                  }}
                                 onChange={({ value }) => {
                                    dropdownSelectionHandler({ target: { name: 'existingCard', value } })
                                }}
                                options={data.map(type => (type.payment_type ===STRIPEBANK ?
                                   { value: type.last4, label: type.last4,icon:<AiFillBank/>}:
                                   { value: type.last4, label: type.last4,icon:<AiFillCreditCard/>}))}>
                            </DropdownMenu>
                    </Row>
                    </Grid>
                   
                </form>
     </div>)
}

export default SavedPaymentMethod;